import axios from "./index";

export default {
  getAll(page, perPage, keyword, type, status, isActive, sortBy, sortType, categoryUUID = "", provinceCode = "", startDate = "", endDate = "") {
    let url = `/v1/blog?page=${page}&perPage=${perPage}&keyword=${keyword}&type=${type}&status=${status}&isActive=${isActive}&sortBy=${sortBy}&sortType=${sortType}`;
    if (categoryUUID) url += `&categoryUUID=${categoryUUID}`;
    if (provinceCode) url += `&provinceCode=${provinceCode}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    return axios.get(url);
  },
  getDetail(uuid) {
    return axios.get(`/v1/blog/${uuid}`);
  },
  getAllTag() {
    return axios.get("/v1/blog/tags");
  },
  createBlog(data) {
    return axios.post("/v1/blog", data);
  },
  updateBlog(data) {
    return axios.put("/v1/blog", data);
  },
  sendApproveBlog(data) {
    return axios.post("/v1/blog/send_approval", data);
  },
  verifyBlog(data) {
    return axios.post("/v1/blog/verify_approval", data);
  },
  requestEditBlog(data) {
    return axios.put("/v1/blog/request_edit", data);
  },
  uploadFile(formData) {
    return axios.post(`/v1/blog/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateBlogHighlight(uuid) {
    return axios.patch(`/v1/blog/update_highlight/${uuid}`);
  },
  getBlogHighlight() {
    return axios.get("/v1/blog/highlight");
  },
  deleteBlog(uuid) {
    return axios.delete(`/v1/blog/${uuid}`);
  },
};
